import { configureStore } from "@reduxjs/toolkit";
import assessmentReducer from "../features/assessmentSlice";
import flagReducer from "../features/flagSlice";
import newAssessmentReducer from "../features/newAssessmentSlice";
import passwordReducer from "../features/passwordSlice";
import popupReducer from "../features/popupSlice";
import submitDataReducer from "../features/submitSlice";
import targetScenarioReducer from "../features/targetScenarioSlice";
import nameReducer from "../features/userSlice";
import workspaceDataReducer from "../features/workspaceDataSlice";

export default configureStore({
  reducer: {
    user: nameReducer,
    password: passwordReducer,
    assessment: assessmentReducer,
    assessmentPopup: popupReducer,
    newAssessment: newAssessmentReducer,
    workspaceData: workspaceDataReducer,
    targetScenario: targetScenarioReducer,
    submitData: submitDataReducer,
    flag: flagReducer,
  },
});
